import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { SwiperConfigInterface, SwiperDirective } from "ngx-swiper-wrapper";
import { PaginationOptions } from "swiper/types/components/pagination";
import { Activity } from "../../models/activity.model";

@Component({
  selector: "common-activity-cards",
  templateUrl: "./activity-cards.component.html",
  styleUrls: ["./activity-cards.component.scss"],
})
export class ActivityCardsComponent implements OnInit {
  @Input() activities: Activity[];
  @Input() header: string = "Tasks";
  @Input() showLength: boolean = true;

  paginationConfig: PaginationOptions = {
    type: "bullets",
    el: ".swiper-pagination",
    bulletActiveClass: "swiper-pagination-bullet-active active-bullet",
    bulletClass: "swiper-pagination-bullet inactive-bullet",
    clickable: true,
    modifierClass: "swiper-pagination-bullets bottom-0",
  };

  @ViewChild(SwiperDirective, { static: false }) directiveRef?: SwiperDirective;

  extraInfoConfig: SwiperConfigInterface = {
    direction: "horizontal",
    slidesPerView: 1.3,
    spaceBetween: 20,
    slidesOffsetBefore: 20,
    observer: true,
    slidesOffsetAfter: 20,
    breakpoints: {
      // when window width is >= 640px
      640: {
        slidesPerView: 2.5,
        spaceBetween: 20,
        slidesOffsetBefore: 50,
        slidesOffsetAfter: 50,
      },
      1023: {
        slidesPerView: 3.3,
        slidesOffsetBefore: 50,
        slidesOffsetAfter: 50,
      },
      1200: {
        slidesPerView: 3.3,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
      },
      1439: {
        slidesPerView: 5,
        spaceBetween: 20,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
      },
    },
    navigation: {
      disabledClass: "swiper-button-disabled disabled",
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    edgeSwipeDetection: true,
    slideToClickedSlide: false,
    updateOnWindowResize: true,
  };
  constructor() {}

  ngOnInit(): void {}

  next() {
    this.directiveRef.nextSlide();
  }

  previous() {
    this.directiveRef.prevSlide();
  }

  dismissed(activity: Activity) {
    this.activities = this.activities.filter(d => d.id != activity.id);
  }
}
